var map = {
	"./BCA.svg": "8563",
	"./BNI.svg": "5e26",
	"./BRI.svg": "b62f",
	"./DANA.svg": "0d60",
	"./GOPAY.svg": "3258",
	"./LINKAJA.svg": "39e5",
	"./MANDIRI.svg": "a530",
	"./OVO.svg": "fe55",
	"./PERMATA.svg": "7fd0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4625";